import axios from "axios"

export default {
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/hazardclass/update' : '/api/hazardclass/create',data)
        return response
    },
    async Table(data){
        const response = await axios.post('/api/hazardclass/table',data)
        return response
    },
    async Delete(id){
        const response = await axios.post(`/api/hazardclass/delete/${id}`)
        return response
    },
    async List(){
        const response = await axios.post('/api/hazardclass/list')
        return response
    },
    async ListWithType(ohs){
        const response = await axios.post(`/api/hazardclass/list/${ohs}`)
        return response
    },
    async NameList(){
        const response = await axios.post('/api/hazardclass/name/list')
        return response
    },
    async CategoryList(){
        const response = await axios.post('/api/hazardclass/category/list')
        return response
    }
}